import React from 'react'
import { useTranslation } from 'react-i18next'

const TradingPlarformsCards = () => {
    const { t } = useTranslation();

    const datas = [
        {
            icon: "fa-solid fa-wand-magic-sparkles fa-lg",
            title: t("Kullanıcı Dostu Arayüz"),
            description: t("Platformlarımız, yatırımcıların kolayca işlem yapabilmesi için tasarlanmıştır. Basit ve anlaşılır arayüz, tüm özelliklere hızlı erişim sağlar, böylece zaman kaybetmeden işlemlerinizi gerçekleştirebilirsiniz.")
        },
        {
            icon: "fa-solid fa-wand-magic-sparkles fa-lg",
            title: t("Gelişmiş Teknik Analiz Araçları"),
            description: t("Paragon Yatırım, yatırımcılarına piyasa hareketlerini daha iyi analiz edebilmesi için kapsamlı teknik analiz araçları sunar. Grafikler, göstergeler ve çizim araçları ile doğru kararlar alabilirsiniz.")
        },
        {
            icon: "fa-solid fa-wand-magic-sparkles fa-lg",
            title: t("Anlık Piyasa Verileri"),
            description: t("En güncel piyasa verileri, yatırımcıların doğru ve hızlı kararlar almasını sağlar. Gerçek zamanlı fiyatlar, alım-satım fırsatlarını kaçırmamanızı garantiler.")
        },
        {
            icon: "fa-solid fa-wand-magic-sparkles fa-lg",
            title: t("Mobil Uyumluluk"),
            description: t("Paragon işlem platformları, mobil cihazlarda da mükemmel çalışır. Dilediğiniz zaman, dilediğiniz yerden işlem yapma özgürlüğü sunarak, yatırımcıların sürekli bağlantıda kalmasını sağlar.")
        },
        {
            icon: "fa-solid fa-wand-magic-sparkles fa-lg",
            title: t("Güvenli ve Hızlı İşlem"),
            description: t("Tüm işlemler, yüksek güvenlik protokolleri ve düşük gecikme süreleriyle gerçekleştirilir. Paragon platformları, güvenli bir ticaret ortamı sunar ve hızlı işlem yapmanıza olanak tanır.")
        },
        {
            icon: "fa-solid fa-wand-magic-sparkles fa-lg",
            title: t("Kişiselleştirilebilir İşlem Alanları"),
            description: t("Her yatırımcıya özel işlem alanları oluşturma imkânı sunar. Kendi ticaret tarzınıza göre platformu özelleştirerek daha verimli bir işlem deneyimi elde edebilirsiniz.")
        },
    ]
    return (
        <div className='trading-platforms-cards-content'>
            <div className="container">
                <div className="row">
                    {
                        datas.map((data, index) => (
                            <div className="col-lg-6 mb-4">
                                <div className="trading-platforms-card shadow-sm mb-lg-0 mb-4">
                                    <div className="row">
                                        <div className="col-lg-2">
                                            <div className="trading-platforms-card-icon shadow mb-lg-0 mb-3">
                                                <i className={data.icon}></i>
                                            </div>
                                        </div>
                                        <div className="col-lg-10 ps-lg-0">
                                            <h5>{data.title}</h5>
                                            <p className="mb-0">
                                                {data.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default TradingPlarformsCards